
<!--

 * @Date: 2022-10-26 10:50:57
 * @LastEditors: chengjia 645680217@qq.com
 * @LastEditTime: 2022-12-06 11:53:42
 * @FilePath: \xm-runing-extend\src\views\msgMain\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
    <div class="flowMsgItem">
        <div class="flowMsgItem__img">
            <img :src="imgUrl()" alt="" />
        </div>
        <div class="flowMsgItem__body">
            <p class="flowMsgItem__body__tongzhi">{{ t('layout.header.流程消息通知') }}</p>
            <div class="flowMsgItem__body__msgItem">
                <div v-show="imgList.length != 0" v-for="(item, index) in imgList" :key="index"
                    class="flowMsgItem__body__msgItem__img">
                    <img style="width: 100%;height:100%" :src="getImgUrl(item.imgurl)" alt="" />
                </div>
                <p class="flowMsgItem__body__msgItem__xmtitle">{{ t('layout.header.应用现代化') }}</p>
                <div v-for="(item, index) in detailList" :key="index" class="flowMsgItem__body__msgItem__msg">
                    <div v-show="item.code === 'textInput'" class="flowMsgItem__body__msgItem__msg__title">
                        {{ item.value }}
                    </div>
                    <div v-show="item.code === 'textarea'" class="flowMsgItem__body__msgItem__msg__center">
                        <span>{{ t('layout.header.消息内容') }}：</span>
                        <span>{{ item.value }}</span>
                    </div>
                    <div v-show="item.code === 'customContent'" v-for="(ite, inde) in item.value" :key="inde"
                        class="flowMsgItem__body__msgItem__msg__customContent">
                        <span>{{ ite.title }}</span>:
                        <span>{{ ite.value }}</span>
                    </div>
                </div>
                <!-- <div class="flowMsgItem__body__msgItem__checkDetail">
                    <span>查看详情</span>
                </div> -->
            </div>

        </div>
    </div>
</template>
    
<script lang="ts">
export default defineComponent({
    components: {},
    name: "flowMsgItem",
});
</script>
    
<script lang="ts" setup>
import {ref,watch} from 'vue'
import SysConfigUtils from '@/utils/sysConfigUtils'
import { msgStore } from '@/store/modules/msgStore'
import { useI18n } from 'vue-i18n';
const{ t }=useI18n()
const store = msgStore()
const { msgDetail } = storeToRefs(store)
let imgList = ref([])
let detailList = ref([])

onMounted(() => {
})
const imgUrl = () => {
    return `${SysConfigUtils.staticUrl}/static/msgTemplate/yulanHeader.png`
}
const getImgUrl = (path?: string) => {
    if (path === '' || path === undefined) {
        return `${SysConfigUtils.staticUrl}/static/msgTemplate/yulanpeijing.png`
    } else {
        return SysConfigUtils.go_eplat_adress + '/api/pe-attachment/attachment/showImg/' + path
    }
}

watch(() => msgDetail.value, (newval, oldval) => {
    let msgContent = JSON.parse((newval as any).content);
    if(msgContent&&Array.isArray(msgContent)){
      imgList.value = msgContent.filter(item => item.name === 'img')
      detailList.value = msgContent.filter(item => item.name !== 'img')
      console.log(imgList, detailList)
    }

}, {
    immediate: true
})
</script>
    
<style type="text/css" lang="less" scoped>
.flowMsgItem {
    max-height: 100%;
    border-radius: 6px;
    display: flex;
    overflow: hidden;

    &__img {
        flex-shrink:0;
        background-color: #f1f2f3;
        margin-right: 8px;
        
        img {
            width: 36px;
            height: 36px;
        }
    }

    &__body {
        width: 280px;

        &__tongzhi {
            width: 100%;
            color: rgba(17, 31, 44, 0.56);
            font-size: 12px;
            font-family: PingFangSC-Regular;
            margin: unset;
            padding-bottom: 10px;
            background-color: #f1f2f3;
        }

        &__msgItem {
            background-color: #fff;
            width: 100%;
            overflow: hidden;
            border-radius: 8px;

            &__img {
                width: 100%;
                height: 160px;
                border-radius: 8px 0px;
            }

            &__xmtitle {
                margin: unset;
                padding: 12px 12px 0;
                color: #0089ff;
                font-size: 15px;
                font-family: PingFangSC-Regular;
                margin-bottom: 8px;
            }

            &__msg {
                width: 100%;

                &__title {
                    padding: 0px 12px;
                    font-size: 14px;
                    margin-bottom: 10px;
                    color: #333;
                    font-family: PingFangSC-Medium;
                    font-weight: 600;
                }

                &__center {
                    padding: 0px 12px;
                    font-size: 14px;
                    color: #666;
                    padding-bottom: 15px;
                    font-family: PingFangSC-Medium;
                    line-height: 20px;
                }

                &__customContent {
                    padding: 0px 12px;
                    font-size: 14px;
                    color: #666;
                    padding-bottom: 15px;
                    font-family: PingFangSC-Medium;
                }
            }

            &__checkDetail {
                width: 100%;
                text-align: center;
                padding: 10px 15px;
                border-top: 1px solid #f1f2f3;
                color: #1890ff;
                font-size: 14px;
                cursor: pointer;
            }
        }


    }

}
</style>
